import { readRuntimeConfig } from './runtimeConfig';
import { resolveApiEndpoint } from './resolveApiEndpoint';

export function isStandinDeploymentOrigin(location?: Location): boolean {
  const target = location ?? (typeof window === 'undefined' ? undefined : window.location);
  if (!target) return false;
  try {
    return resolveApiEndpoint({
      host: target.host,
      origin: target.origin,
      pathname: target.pathname,
      runtimeConfig: readRuntimeConfig(),
    }).isStandinDeployment;
  } catch {
    return false;
  }
}
